import DefaultModal from "./default-modal";

export default { DefaultModal };
